import { TextAreaField } from '@origin-digital/style-guide';
import React from 'react';
import analytics from '../../../../analytics';

import { TextAreaAdapterProps } from './TextAreaAdapter.types';

const TextAreaAdapter = (props: TextAreaAdapterProps): JSX.Element => {
  const { field, form, label, maxLength } = props;

  return (
    <TextAreaField
      name={field.name}
      value={field.value}
      label={label}
      maxLength={maxLength}
      onChange={field.onChange}
      onBlur={field.onBlur}
      touched={form.errors[field.name] !== undefined && form.touched[field.name]}
      error={form.errors[field.name]}
      //@ts-ignore
      onClick={e => analytics.firstInteraction()}
    />
  );
};

export { TextAreaAdapter as default };
